import { render, staticRenderFns } from "./FilterBox.vue?vue&type=template&id=3ecfa95a"
import script from "./FilterBox.vue?vue&type=script&lang=js"
export * from "./FilterBox.vue?vue&type=script&lang=js"
import style0 from "./FilterBox.vue?vue&type=style&index=0&id=3ecfa95a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports